// config.js

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBFlADVcpRbCya6mUtvBE5U4JOUEJ0-pS8",
  authDomain: "clubnjoy-d756f.firebaseapp.com",
  databaseURL: "https://clubnjoy-d756f-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "clubnjoy-d756f",
  storageBucket: "clubnjoy-d756f.appspot.com",
  messagingSenderId: "705874047531",
  appId: "1:705874047531:web:f045512b685c36fddbb06e",
  measurementId: "G-FGDWJFNB5N"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };